import i18n from '@newspaces/lucky-base/i18n'

import enLanguage from './languages/en'

i18n.registerLanguage('en', enLanguage)

export default i18n
